<template>
  <div class="additional-info">
    <van-nav-bar
      :fixed="true"
      z-index="9"
      :title="$t('additionalInfo.submissionResultTitle')"
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="result-content">
      <div class="result-content__images">
        <img src="@/assets/img/additional-info/success_header_icon_full.svg" alt="" />
        <img src="@/assets/img/additional-info/sparkles_circles.svg" alt="" class="result-content__images-overlay result-content__images-overlay--left" />
        <img src="@/assets/img/additional-info/sparkles_circles.svg" alt="" class="result-content__images-overlay result-content__images-overlay--right" />
      </div>
      <div class="result-content__title">{{ $t('additionalInfo.submissionResult.title') }}</div>
      <div class="result-content__desc">
        <div>{{ $t('additionalInfo.submissionResult.desc1') }}</div>
        <div>{{ $t('additionalInfo.submissionResult.desc2') }}</div>
      </div>
    </div>
    <!-- Tip -->
    <div class="tip-banner">
      <div class="tip-banner__icon">
        <van-icon name="info" />
      </div>
      <div class="tip-banner__text">{{ $t('additionalInfo.tipBanner') }}</div>
    </div>

    <div class="footer-placeholder"></div>

    <!-- Go Home Button -->
    <div class="additional-info__footer">
      <div class="btn-primary" @click="onGoHome">
        {{ $t('additionalInfo.goHome') }}
      </div>
    </div>
  </div>
</template>
<script>
import routerBack from "@/mixins/routerBack";
import {Icon} from "vant";

export default {
  name: 'AdditionalInfoSubmitSuccess',
  mixins: [routerBack],
  components: {
    'van-icon': Icon,
  },
  data() {
    return {}
  },
  computed: {
  },
  created() {
  },
  methods: {
    onClickLeft() {
      this.goBack()
    },
    onGoHome() {
      this.$router.replace('/index')
    },
  }
}
</script>

<style scoped lang="less">
.additional-info {
  min-height: 100vh;
  padding: 88px 24px 200px;
  background: var(--bg-color);
  box-sizing: border-box;

  .result-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-top: 120px;

    &__images {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        max-width: 280px;
        height: auto;
      }
    }

    &__images-overlay {
      position: absolute;

      &--left {
        left: -90px;
        transform: scaleX(-1) rotate(-77deg);
      }
      &--right {
        right: -90px;
        transform: rotate(-77deg);
      }
    }

    &__title {
      margin-top: 40px;
      font-size: 36px;
      font-weight: 600;
      line-height: 50px;
      color: var(--text-color-black);
    }

    &__desc {
      margin-top: 20px;
      font-size: 26px;
      line-height: 38px;
      color: #666;
      padding: 0 8px;

      > div + div {
        margin-top: 12px;
      }
    }
  }

  .tip-banner {
    margin-top: 24px;
    padding: 24px 28px;
    background: #EAF1FF;
    border-radius: 16px;
    display: flex;
    align-items: flex-start;

    &__icon {
      flex-shrink: 0;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: var(--primary-color);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      margin-top: 4px;
    }

    &__text {
      margin-left: 20px;
      font-size: 26px;
      line-height: 38px;
      color: #4A5A7A;
      flex: 1;
    }
  }

  .footer-placeholder {
    height: 40px;
  }

  &__footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 24px 32px 40px;
    background: var(--bg-color);
    z-index: 10;
  }
}
</style>
